import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './queryClient.js'
import App from './App.jsx'
import { RootBoundary } from './ui/RootBoundary.jsx'
import './index.css'

/*
 * THE ROOT BOUNDARY SITS ABOVE EVERYTHING, including App's own hooks and the
 * router. Putting it inside App would leave a throw in App itself uncaught,
 * which is the same white screen one level up.
 *
 * It is INSIDE the providers deliberately: the crash screen renders Screen,
 * which renders the support affordance, and anything that reaches for a
 * provider must still find one.
 *
 * Nesting does the work. React hands a throw to the INNERMOST boundary, so a
 * crash on an answering surface is still caught by BatteryBoundary and still
 * gets the sentence about saved answers. This one only ever sees what that one
 * did not — Settings, Home, consent, install, and the withdrawal screen, where
 * a blank page is the last thing the app would ever show her.
 */
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <RootBoundary>
          <App />
        </RootBoundary>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
